import { ActivityLogRow, ChangeEntry } from "./types";

export const transformActivityLogRow = (res: any): ActivityLogRow => {
  let changes: ChangeEntry[] | null = null;

  if (res.changes) {
    try {
      changes = typeof res.changes === "string" ? JSON.parse(res.changes) : res.changes;
    } catch {
      changes = null;
    }
  }

  return {
    id: res.id,
    comment: res.comment,
    entityName: res.entityName,
    entityId: res.entityId,
    activityLogType: res.activityLogType,
    activityLogTypeName: res.activityLogTypeName,
    userFullName: res.userFullName,
    userId: res.userId,
    created: res.created,
    changes,
    entityDescription: res.entityDescription ?? null,
  };
};
